import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/home/HeroSection';
import { ValuePillars } from '../components/home/ValuePillars';
import { ProgramsPreview } from '../components/home/ProgramsPreview';
import { WhyTrainHere } from '../components/home/WhyTrainHere';
import { LocationsPreview } from '../components/home/LocationsPreview';
import { CTASection } from '../components/home/CTASection';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-752">
      <Header data-id="element-753" />

      <main data-id="element-754">
        <HeroSection data-id="element-755" />
        <ValuePillars data-id="element-756" />
        <ProgramsPreview data-id="element-757" />
        <WhyTrainHere data-id="element-758" />
        <LocationsPreview data-id="element-759" />
        <CTASection data-id="element-760" />
      </main>

      <Footer data-id="element-761" />
    </div>;
}